import { render, staticRenderFns } from "./CaseDispatch.vue?vue&type=template&id=9e082f5c&scoped=true&scoped=true&"
import script from "./CaseDispatch.vue?vue&type=script&lang=js&"
export * from "./CaseDispatch.vue?vue&type=script&lang=js&"
import style0 from "./CaseDispatch.vue?vue&type=style&index=0&id=9e082f5c&scoped=true&lang=css&"
import style1 from "./CaseDispatch.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e082f5c",
  null
  
)

export default component.exports